const path = "/aether";
const authorize_path = `${path}/auth`;
const rpm_path = `${authorize_path}/rpm`;

export const CHECK_DHCP_PACKAGE_STATUS = `${rpm_path}/check-dhcp`;
